var map = {
	"./bronze-crown.svg": 10334,
	"./bronze-transition-crown.svg": 69358,
	"./diamond-crown.svg": 36586,
	"./diamond-transition-crown.svg": 7618,
	"./gold-crown.svg": 59912,
	"./gold-transition-crown.svg": 85872,
	"./platinum-crown.svg": 2350,
	"./platinum-transition-crown.svg": 50974,
	"./silver-crown.svg": 76145,
	"./silver-transition-crown.svg": 74511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72079;